module.exports = __webpack_public_path__ + "img/org.45e99c6a.png";